export { GrillaModule } from './grilla.module';
export { Grilla } from './grilla.component';
export * from './interfaces';
